import type {
  StudyAnalysisReviewItem,
  StudyAnalysisReviewSource,
} from './studyAnalysisFollowUpApi';
import { questionLabel } from './studySessionQuestion';

/** Why an analysed material or question is in Review (study-capture-fixes-prd.md G-03). */
export const ANALYSIS_REVIEW_SOURCE_COPY: Record<StudyAnalysisReviewSource, string> = {
  practice_wrong: 'Wrong in a practice set',
  learner_request: 'You asked to review this',
  marked_wrong: 'Marked wrong on your test',
  answer_check: 'Your answer needed another look',
};

/** "Q3 · Quadratics", "Quadratics", or the file name when the analysis has no topic. */
export function analysisReviewTitle(item: StudyAnalysisReviewItem): string {
  const topic = item.topic?.trim() || item.document_name;
  if (!item.question_id) return topic;
  if (item.self_assessment) return `Assessment question ${item.question_number ?? ''} · ${topic}`;
  if (item.practice_set_id) return `Practice question ${item.question_number ?? ''} · ${topic}`;
  // A question the learner removed later keeps its item; it opens the whole material.
  return item.question_number
    ? `${questionLabel({ number: item.question_number })} · ${topic}`
    : `A question · ${topic}`;
}

export function analysisReviewSourceCopy(item: StudyAnalysisReviewItem): string {
  return item.self_assessment && item.source === 'practice_wrong'
    ? 'Wrong in a self-assessment'
    : ANALYSIS_REVIEW_SOURCE_COPY[item.source];
}
